import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import useInTheWorld from "../hooks/useInTheWorld";
import usePgiModules from "../hooks/useModules";
import BannerPub from "../components/BannerPub";
import images from "../exports/images";
import CarouselMobile from "../components/carousel/CarouselMobile";
import CarouselMobileProdEspeciales from "../components/carousel/CarouselMobileProdEspeciales";
import ModuleBlockNews from "../components/news/ModuleBlockNews";
import MapGoogle from "../components/mapsGoogle/MapGoogle";
import { postConsulta } from "../helpers/contacto";

import useMAps from "../hooks/useMaps";
import { useEnElMundoFormValidator } from "../hooks/useEnElMundoFormValidator";

const EnElMundo = () => {
  const isEnElMundoPage = true;
  const [homeModules, setHomeModules] = useState([]);
  const { getModulesByParams } = usePgiModules();

  useEffect(() => {
    getModulesByParams({ state: true }).then((res) => {
      setHomeModules(res.sort((a, b) => a.position - b.position));
    });
    document.title = "Tensolite in the world";
  }, []);

  const [formValue, setFormValue] = useState({
    origin: "0",
    name: "",
    company: "",
    email: "",
    codCountry: "",
    codArea: "",
    phone: "",
    idPassport: "",
    country: "",
    state: "",
    city: "",
    subject: "",
    message: "",
    mundo: true,
  });

  const { errors, validateForm, onBlurField } = useEnElMundoFormValidator(formValue);

  const handleChange = ({ target }) => {
    const field = target.name;

    const nextFormState = {
      ...formValue,
      [field]: target.value
    };

    if (target) {
      setFormValue({
        ...formValue,
        [target.name]: target.value
      });

      if (errors[field].dirty) {
        validateForm({
          form: nextFormState,
          errors,
          field
        });
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { isValid } = validateForm({
      form: formValue,
      errors,
      forceTouchErrors: true
    });
    if (!isValid) return;

    postConsulta(formValue)
      .then((respuesta) => {
        if (respuesta) {
          toast.success("Submitted form!");
        }
        if (respuesta.errors) {
          return window.alert(respuesta.errors[0].msg);
        }
        if (respuesta.msg) {
          window.alert(respuesta.msg);
        }

        setFormValue({
          origin: "0",
          name: "",
          company: "",
          email: "",
          codCountry: "",
          codArea: "",
          phone: "",
          idPassport: "",
          country: "",
          state: "",
          city: "",
          subject: "",
          message: "",
          mundo: true,
        });
      })
      .catch((error) => {
        console.log("⚡ ~ error", error);
        if (Object.keys(errors).length !== 0) {
          toast.error("The form could not be sent, please check the fields");
        }
      });
  };

  const {
    centerInTheWorldMedium,
    centerInTheWorldSmall,
  } = useMAps();
  const { inTheWorld } = useInTheWorld();

  const newArray = {
    ...inTheWorld,
    locations: inTheWorld?.locations?.sort(function (o1, o2) {
      if (o1.country > o2.country) {
        return 1;
      } else if (o1.country < o2.country) {
        return -1;
      }
      return 0;
    })
  };

  return (
    <>
      <div id="intheWorld" className="bg-fullpage">
        <MapGoogle
          markers={newArray ? newArray?.locations : ""}
          center={window.innerWidth < 575 ? centerInTheWorldSmall : centerInTheWorldMedium}
          zoom={3}
          data={newArray?.locations}
        />
        <section className="container halfintro">
          <div className="card-info card-world col-12 col-xl-7 col-lg-7 col-md-6 col-sm-12">
            <div className="cuadrado-azul"></div>
            <h1 className="text-world">{inTheWorld?.title}</h1>
          </div>
          <div id="locations-intro" className="card-info col-12 col-xl-7 col-lg-7 mt-1">
            {newArray?.locations?.map((loc, index) => (
              <div key={index} className="intheWorld__locations world_desktop d-flex">
                {loc?.country === "Argentina" && index !== 0 ? (
                  <h2 className="col-3"> </h2>
                ) : loc?.country === "Argentina" && index === 0 ? (
                  <h2 className="col-3">{loc?.country}</h2>
                ) : (
                  <h2 className="col-3">{loc?.country}</h2>
                )}
                <ul>
                  <h3>{loc?.province}</h3>
                  <li>{loc?.phone}</li>
                  <li>
                    {loc?.address} <br />
                    {loc?.postal_code} {loc?.locality}, {loc?.province}
                  </li>
                  <li>{loc?.email}</li>
                </ul>
              </div>
            ))}
          </div>
        </section>
      </div>
      {/* seccion inferior */}
      {/*seccton visible a partir de 1200 px */}
      <section className="intheWorld__locations-botton">
        <div className="container padding-world">
          <div className="intheWorld__locations mt-5">
            {newArray?.locations?.map((loc, index) => (
              <div key={index} className="intheWorld__locations columns-width d-flex">
                {loc?.country === "Argentina" && index !== 0 ? (
                  <h2 className="col-3"> </h2>
                ) : loc?.country === "Argentina" && index === 0 ? (
                  <h2 className="col-3">{loc?.country}</h2>
                ) : (
                  <h2 className="col-3">{loc?.country}</h2>
                )}
                <ul>
                  <h3>{loc?.province}</h3>
                  <li>{loc?.phone}</li>
                  <li>
                    {loc?.address} <br />
                    {loc?.postal_code} {loc?.locality}, {loc?.province}
                  </li>
                  <li>{loc?.email}</li>
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section id="intheWorld__contact-world" className="container">
        <header>
          <h2>Contact us</h2>
        </header>

        {/* Seccion columna izquierda */}

        <form id="form_tenso_world" className="settings__form-styles">
          <fieldset className="col-12 col-sm-12 col-md-6 col-lg-6 settings__col-izquierda">
            <div className="mb-4 col-12">
              <input
                id="nombre-cliente"
                name="name"
                type="text"
                className={`${errors.name.error ? "red-advertise" : ""} `}
                value={formValue.name}
                onChange={handleChange}
                onBlur={onBlurField}
                placeholder="Full name"
                maxLength={40}
                minLength={2}
                required
              />
              {errors.name.dirty && errors.name.error ? (
                <p className="errors-msg">{errors.name.message}</p>
              ) : null}
              {/* {errors.name && <p className="errors-msg">{errors.name}</p>} */}
            </div>
            <div className="mb-4 col-12">
              <input
                id="company"
                name="company"
                type="text"
                className={`${errors.company.error ? "red-advertise" : ""} `}
                value={formValue.company}
                onChange={handleChange}
                onBlur={onBlurField}
                placeholder="Company"
                maxLength={30}
                minLength={2}
                required
              />
              {errors.company.dirty && errors.company.error ? (
                <p className="errors-msg">{errors.company.message}</p>
              ) : null}
            </div>
            <div className="mb-4 col-12">
              <input
                id="email"
                name="email"
                type="email"
                className={`${errors.email.error ? "red-advertise" : ""} `}
                value={formValue.email}
                onChange={handleChange}
                onBlur={onBlurField}
                placeholder="Email"
                maxLength={40}
                minLength={2}
                required
              />
              {errors.email.dirty && errors.email.error ? (
                <p className="errors-msg">{errors.email.message}</p>
              ) : null}
            </div>
            <div className="mb-4">
              <div className="row">
                <div className="col-3">
                  <input
                    id="cod-pais"
                    name="codCountry"
                    type="tel"
                    className={`${errors.codCountry.error ? "red-advertise" : ""} `}
                    value={formValue.codCountry}
                    onChange={handleChange}
                    onBlur={onBlurField}
                    placeholder="Phone Code"
                    maxLength={6}
                    required
                  />
                  {errors.codCountry.dirty && errors.codCountry.error ? (
                    <p className="errors-msg">{errors.codCountry.message}</p>
                  ) : null}
                </div>
                <div className="col-4">
                  <input
                    id="cod-area"
                    name="codArea"
                    type="tel"
                    className={`${errors.codArea.error ? "red-advertise" : ""} `}
                    value={formValue.codArea}
                    onChange={handleChange}
                    onBlur={onBlurField}
                    placeholder="Area"
                    maxLength={10}
                    required
                  />
                  {errors.codArea.dirty && errors.codArea.error ? (
                    <p className="errors-msg">{errors.codArea.message}</p>
                  ) : null}
                </div>
                <div className="col-5">
                  <input
                    id="telefono"
                    name="phone"
                    type="tel"
                    className={`${errors.phone.error ? "red-advertise" : ""} `}
                    value={formValue.phone}
                    onChange={handleChange}
                    onBlur={onBlurField}
                    placeholder="Phone number"
                    maxLength={20}
                    required
                  />
                  {errors.phone.dirty && errors.phone.error ? (
                    <p className="errors-msg">{errors.phone.message}</p>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="col-12 d-flex mb-4 justify-content-between">
              <div className="col-6-mr-form">
                <input
                  id="id-passport"
                  name="idPassport"
                  type="text"
                  className={`${errors.idPassport.error ? "col-6 red-advertise" : "col-6"} `}
                  value={formValue.idPassport}
                  onChange={handleChange}
                  onBlur={onBlurField}
                  placeholder="Id or Passport"
                  maxLength={30}
                  minLength={2}
                  required
                />
                {errors.idPassport.dirty && errors.idPassport.error ? (
                  <p className="errors-msg">{errors.idPassport.message}</p>
                ) : null}
              </div>
              <div className="col-6-ml-form">
                <input
                  id="country"
                  name="country"
                  type="text"
                  className={`${errors.country.error ? "red-advertise" : ""} `}
                  value={formValue.country}
                  onChange={handleChange}
                  onBlur={onBlurField}
                  placeholder="Country"
                  maxLength={30}
                  minLength={2}
                  required
                />
                {errors.country.dirty && errors.country.error ? (
                  <p className="errors-msg">{errors.country.message}</p>
                ) : null}
              </div>
            </div>
            <div className="col-12 d-flex ">
              <div className="col-6-mr-form">
                <input
                  id="state"
                  name="state"
                  type="text"
                  className={`${errors.state.error ? "red-advertise" : ""} `}
                  value={formValue.state}
                  onChange={handleChange}
                  onBlur={onBlurField}
                  placeholder="State"
                  maxLength={30}
                  minLength={2}
                  required
                />
                {errors.state.dirty && errors.state.error ? (
                  <p className="errors-msg">{errors.state.message}</p>
                ) : null}
              </div>
              <div className="col-6-ml-form">
                <input
                  id="city"
                  name="city"
                  type="text"
                  className={`${errors.city.error ? "red-advertise" : ""} `}
                  value={formValue.city}
                  onChange={handleChange}
                  onBlur={onBlurField}
                  placeholder="City"
                  maxLength={30}
                  minLength={2}
                  required
                />
                {errors.city.dirty && errors.city.error ? (
                  <p className="errors-msg">{errors.city.message}</p>
                ) : null}
              </div>
            </div>
          </fieldset>
          <fieldset className="col-12 col-sm-12 col-md-6 col-lg-6 settings__col-derecha">
            <div className="mb-4 col-12">
              <select
                onChange={handleChange}
                name="subject"
                value={formValue.subject}
                onBlur={onBlurField}
                className={`${errors.subject.error ? "red-advertise" : ""} `}
              >
                <option value={0} hidden selected>
                  What is your question?
                </option>
                <option value={1}>Special Products</option>
                <option value={2}>
                  Technical question about a special product
                </option>
                <option value={3}>Customer support</option>
                <option value={4}>Technical support</option>
                <option value={5}>I want to visit the factory</option>
                <option value={6}>I am a warehouse and I want to buy</option>
              </select>
              {errors.subject.dirty && errors.subject.error ? (
                <p className="errors-msg">{errors.subject.message}</p>
              ) : null}
            </div>
            <div className="mb-4 col-12">
              <textarea
                id="descripcion"
                name="message"
                type="text"
                value={formValue.message}
                onChange={handleChange}
                onBlur={onBlurField}
                className={`col-12 ${errors.message.error ? "shadow2 red-advertise" : "shadow2"} `}
                placeholder="Enter your message"
                maxLength={300}
                minLength={2}
                required
              />
              {errors.message.dirty && errors.message.error ? (
                <p className="errors-msg">{errors.message.message}</p>
              ) : null}
            </div>
            <button
              className="settings_button-pleno bg-p-secondary mb-4 d-flex justify-content-between"
              onClick={handleSubmit}
            >
              Submit <ArrowForwardIcon />
            </button>
          </fieldset>
        </form>
      </section>

      {/* Modulos */}
      {homeModules.map((item, index) => {
        switch (item.title) {
          case "Banner_publicitario":
            if (item.visible.includes("world")) {
              return (
                <>
                  <BannerPub key={index} idProducto={"world"} />
                </>
              );
            }
            break;
          case "Bloque_info":
            if (item.visible.includes("world")) {
              return <ModuleBlockNews key={index} idProducto={"world"} />;
            }
            break;
          default:
        }
      })}
      {homeModules.map((item, index) => {
        switch (item.title) {
          case "Carrousel_deLinea":
            if (item.visible.includes("world")) {
              return (
                <div key={index} className="container producto-linea">
                  <CarouselMobile isEnElMundoPage={isEnElMundoPage} images={images[0]} />
                  {/* <CarouselP images={images[0]} /> */}
                </div>
              );
            }
            break;
          case "Carrousel_especial":
            if (item.visible.includes("world")) {
              return (
                <div key={index} className="container producto-linea mb-5">
                  <CarouselMobileProdEspeciales
                    isEnElMundoPage={isEnElMundoPage}
                    images={images[1]}
                  />
                  {/* <CarouselProdEspeciales key={index} images={images[1]} /> */}
                </div>
              );
            }
            break;
          default:
        }
      })}
    </>
  );
};

export default EnElMundo;
